import { Controls } from "reactflow";
// TODO, could combine all assets into one file, but this is easier to read - Check with Ben

function CustomControls() {
  //All the default controls are included automatically, but they can be excluded through props - see docs
  return <Controls></Controls>;
}

export default CustomControls;
